import vEditorComponent from './index.vue'
const vEditor = {
  install: function(Vue) {
    Vue.component('vEditor', vEditorComponent)
  }
}
export default vEditor
